module.exports = __webpack_public_path__ + "images/boat.9e9339e4ca2b4a0886dff136827e50b7.svg";